<template>
    <div class="nav-links" :class="{ 'nav-active': isMenuOpen }" @click.self="closeMenu">
        <!-- Navigation Section -->

        <!-- Language Section -->
        <div class="language-section">
            <!-- <div class="language-title">Language</div> -->
            <div class="language-flags">
                <button class="flag-button" :class="{ 'active': currentLanguage === 'sk' }"
                    @click="changeLanguage('sk')">
                    <img src="/flags/sk.png" alt="Slovensky" />
                </button>
                <button class="flag-button" :class="{ 'active': currentLanguage === 'en' }"
                    @click="changeLanguage('en')">
                    <img src="/flags/en.png" alt="English" />
                </button>
                <button class="flag-button" :class="{ 'active': currentLanguage === 'de' }"
                    @click="changeLanguage('de')">
                    <img src="/flags/de.png" alt="Deutsch" />
                </button>
                <button class="flag-button" :class="{ 'active': currentLanguage === 'pl' }"
                    @click="changeLanguage('pl')">
                    <img src="/flags/pl.png" alt="Polski" />
                </button>
                <button class="flag-button" :class="{ 'active': currentLanguage === 'hu' }"
                    @click="changeLanguage('hu')">
                    <img src="/flags/hu.png" alt="Magyar" />
                </button>
            </div>
        </div>
        <div class="nav-section">
            <router-link :to="{ path: `/${currentLanguage}` }" @click="() => navMenuClick('Home')">{{ $t('nav.home') }}</router-link>
            <router-link :to="{ path: `/${currentLanguage}${getAboutPath}` }" @click="() => navMenuClick('About')">{{ $t('nav.about') }}</router-link>
            <router-link :to="{ path: `/${currentLanguage}${getApartmentsPath}` }" @click="() => navMenuClick('Apartments')">{{ $t('nav.apartments') }}</router-link>
            <router-link :to="{ path: `/${currentLanguage}${getGalleryPath}/ap1` }" @click="() => navMenuClick('Photogallery')">{{ $t('nav.photogallery') }}</router-link>
            <router-link :to="{ path: `/${currentLanguage}${getTipsPath}` }" @click="() => navMenuClick('Tips')">{{ $t('nav.tips') }}</router-link>
            <router-link :to="{ path: `/${currentLanguage}${getContactPath}` }" @click="() => navMenuClick('Contact')">{{ $t('nav.contact') }}</router-link>
        </div>
        <!-- Overlay -->
    </div>
    <div class="menu-overlay" :class="{ 'active': isMenuOpen }" @click="closeMenu"></div>
</template>

<script>
import { logMessage } from '../../../utils/flaskapi';

export default {
    name: 'NavMenu',
    props: {
        isMenuOpen: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            currentLanguage: 'sk',
            routeMappings: {
                'contact': {
                    'en': '/contact',
                    'sk': '/kontakt',
                    'de': '/kontakt',
                    'pl': '/kontakt',
                    'hu': '/kapcsolat'
                },
                'about': {
                    'en': '/about',
                    'sk': '/o-nas',
                    'de': '/uber-uns',
                    'pl': '/o-nas',
                    'hu': '/rolunk'
                },
                'apartments': {
                    'en': '/apartments',
                    'sk': '/apartmany',
                    'de': '/apartments',
                    'pl': '/apartamenty',
                    'hu': '/apartmanok'
                },
                'gallery': {
                    'en': '/gallery',
                    'sk': '/galeria',
                    'de': '/galerie',
                    'pl': '/galeria',
                    'hu': '/galeria'
                },
                'tips': {
                    'en': '/tips',
                    'sk': '/tipy',
                    'de': '/tipps',
                    'pl': '/porady',
                    'hu': '/tippek'
                }
            }
        }
    },
    computed: {
        getContactPath() {
            return this.routeMappings.contact[this.currentLanguage] || '/contact';
        },
        getAboutPath() {
            return this.routeMappings.about[this.currentLanguage] || '/about';
        },
        getApartmentsPath() {
            return this.routeMappings.apartments[this.currentLanguage] || '/apartments';
        },
        getGalleryPath() {
            return this.routeMappings.gallery[this.currentLanguage] || '/gallery';
        },
        getTipsPath() {
            return this.routeMappings.tips[this.currentLanguage] || '/tips';
        },
        getCurrentPageKey() {
            const currentPage = this.$route.path.split('/')[2] || '';
            for (const [key, translations] of Object.entries(this.routeMappings)) {
                const paths = Object.values(translations).map(path => path.substring(1)); // Remove leading slash
                if (paths.includes(currentPage)) {
                    return key;
                }
            }
            return '';
        }
    },
    methods: {
        closeMenu() {
            this.$emit('update:is-menu-open', false);
        },
        navMenuClick(button) {
            logMessage('info', `Nav_menu_${button}`);
            this.closeMenu()
        },
        changeLanguage(newLang) {
            logMessage('info', `Changing_language_to_${newLang}`);
            this.currentLanguage = newLang;
            this.$i18n.locale = newLang;
            
            // Get current page key and construct new path
            const pageKey = this.getCurrentPageKey;
            const newPath = pageKey
                ? `/${newLang}${this.routeMappings[pageKey][newLang]}`
                : `/${newLang}`;
            
            this.$router.push(newPath);
            this.closeMenu();
        }
    },
    created() {
        // Set initial language based on route
        const lang = this.$route.path.split('/')[1] || localStorage.getItem("preferredLanguage") || 'sk';
        this.currentLanguage = lang;
    },
    watch: {
      '$route'() {
        const lang = this.$route.path.split('/')[1] || localStorage.getItem("preferredLanguage") || 'sk';
        this.currentLanguage = lang;
      }
    }
}
</script>

<style scoped>
.nav-links {
    position: fixed;
    left: -100%;
    top: 0;
    height: 100%;
    width: 250px;
    min-height: 150px;
    background-color: var(--primary-color);
    display: flex;
    flex-direction: column;
    padding: var(--spacing-xl) var(--spacing-lg);
    transition: left 0.3s ease;
    z-index: 96;
    overflow-y: auto;
}

.nav-links.nav-active {
    left: 0;
}

.nav-links.nav-active~.burger-menu {
    transform: translateX(250px);
}

/* Navigation section */
.nav-section {
    flex: 1;
    min-height: min-content;
}

.nav-links a {
    color: var(--white);
    text-decoration: none;
    padding: var(--spacing-md);
    font-size: var(--font-lg);
    font-weight: 700;
    text-align: center;
    transition: color 0.5s ease;
    display: block;
}

.nav-links a:hover,
.nav-links a.router-link-exact-active {
    color: var(--secondary-color-light);
    transition: transform 0.5s ease;
}

.nav-links a:hover {
    transform: scale(1.15);
    transition: transform 0.5s ease;
    transform: translatex(0.5rem);
}

/* Language section */
.language-section {
    margin-top: 0;
    margin-bottom: auto;
    padding: var(--spacing-md);
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    min-height: min-content;
    width: 100%;
}

.language-title {
    color: var(--white);
    font-size: var(--font-sm);
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: var(--spacing-md);
    opacity: 0.8;
    text-align: center;
}

.language-flags {
    display: flex;
    gap: var(--spacing-md);
    justify-content: center;
    align-items: center;
}

.flag-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    opacity: 0.4;
    transition: opacity 0.3s ease;
    width: 28px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.flag-button.active {
    opacity: 1;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
    border-radius: 4px;
}

.flag-button:hover {
    opacity: 1;
}

.flag-button img {
    width: 20px;
    height: 15px;
    border-radius: 4px;
    display: block;
}
</style>